import { render } from "./languageTranslation.vue?vue&type=template&id=0b39a3b5&scoped=true"
import script from "./languageTranslation.vue?vue&type=script&lang=js"
export * from "./languageTranslation.vue?vue&type=script&lang=js"

import "./languageTranslation.vue?vue&type=style&index=0&id=0b39a3b5&lang=scss&scoped=true"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b39a3b5"]])

export default __exports__